export default __webpack_public_path__ + "static/media/icn_data_searching.71ddfb27.svg";